import {FC} from 'react'
import {Presenter} from './Presenter'

export const Index: FC = () => <Presenter />
